import { render } from "./Button.vue?vue&type=template&id=2fea50a2&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=2fea50a2&scoped=true&lang=scss"

import exportComponent from "/Users/leopons/Desktop/Projects/cryptos/bubble-graph/bubblemaps-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fea50a2"]])

export default __exports__